import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap-v5';
import { LoadingGrid } from '../../../../../rbts/helpers';
import { SubSeccionModel, AsientoModel } from '../models/SubSeccionModel';
import { obtenerAsientos } from '../../../../service/boletera/EventosBoletera';

type Props = {
  show: boolean;
  subseccion: SubSeccionModel | null;
  handleClose: () => void;
};

const ESTATUS_BADGE: Record<string, string> = {
  disponible: 'badge-light-success',
  hold:       'badge-light-warning',
  vendido:    'badge-light-danger',
};

const ModalListaAsientos: React.FC<Props> = ({ show, subseccion, handleClose }) => {
  const [asientos, setAsientos] = useState<AsientoModel[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!show || !subseccion) return;
    setLoading(true);
    obtenerAsientos(subseccion.id)
      .then(setAsientos)
      .catch(() => setAsientos([]))
      .finally(() => setLoading(false));
  }, [show, subseccion]);

  return (
    <Modal show={show} onHide={handleClose} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title className="fw-bold">
          Asientos — <span className="text-muted fw-normal">{subseccion?.nombre}</span>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="py-4 px-6" style={{ maxHeight: 480, overflowY: 'auto' }}>
        {loading ? (
          <LoadingGrid text="Cargando asientos..." />
        ) : asientos.length === 0 ? (
          <div className="text-center text-muted py-8">
            No hay asientos generados. Usa "Regenerar asientos" para crearlos.
          </div>
        ) : (
          <table className="table table-row-dashed table-row-gray-300 align-middle gs-0 gy-2">
            <thead>
              <tr className="fw-bolder text-muted">
                <th>FILA</th>
                <th>NÚMERO</th>
                <th>ESTATUS</th>
              </tr>
            </thead>
            <tbody>
              {asientos.map((a) => (
                <tr key={a.id}>
                  <td>{a.fila}</td>
                  <td>{a.numero}</td>
                  <td>
                    <span className={`badge ${ESTATUS_BADGE[a.estatus] || 'badge-light'}`}>
                      {a.estatus}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </Modal.Body>
      <Modal.Footer>
        <div className="text-muted fs-7 me-auto">
          {asientos.length > 0 && `${asientos.length.toLocaleString()} asientos`}
        </div>
        <button className="btn btn-light" onClick={handleClose}>Cerrar</button>
      </Modal.Footer>
    </Modal>
  );
};

export { ModalListaAsientos };
